import _axios, {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosInstance,
  AxiosStatic
} from "axios";
import { sortByPrio } from "./utils";
import { AxiosPrioInterceptorManager } from "./interceptor";
import { useAxiosPluginManager } from "./plugin";
import { AxiosTransformer, AxiosTransformerType } from "./types";

customizeAxios(_axios);

export const createAxios = _axios.create;

_axios.create = function(config?: AxiosRequestConfig) {
  const instance = createAxios(config);
  customizeAxios(instance);
  return instance;
};

export function addPrioToTransformer(axios: AxiosInstance | AxiosStatic) {
  axios.defaults = new Proxy(axios.defaults, {
    get(target, prop) {
      const keys = [
        AxiosTransformerType.request,
        AxiosTransformerType.response
      ] as string[];
      if (typeof prop !== "string" || !keys.includes(prop)) return target[prop];
      if (!Array.isArray(target[prop])) return target[prop];
      return sortByPrio(target[prop] as AxiosTransformer[]);
    }
  });
}

export function customizeAxios(axios: AxiosInstance | AxiosStatic) {
  axios.interceptors.request = new AxiosPrioInterceptorManager<
    AxiosRequestConfig
  >();
  axios.interceptors.response = new AxiosPrioInterceptorManager<
    AxiosResponse
  >();
  useAxiosPluginManager(axios);
  addPrioToTransformer(axios);
  return axios;
}

export const axios = _axios;
